import { API } from './resources'

export default {
  get: (formId, includeUser, includeQuestions, includeAnswers, getAllQuestions) => {
    return API.get('/forms/questions', { params: { formId, includeUser, includeQuestions, includeAnswers, getAllQuestions, pageSize: 25 } })
  },
  saveUserFormQuestionAnswers: (data) => {
    return API.post('/forms/answers', data)
  },
  getQuestionnaireForm: (data) => {
    return API.post('/forms/questionnaire', data)
  }
}
